import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { IframeData } from '../../../shared/public-api';

@Component({
  selector: 'admin-iframe-section',
  templateUrl: './iframe-section.component.html',
  styleUrls: ['./iframe-section.component.scss'],
  imports: [FormsModule, CommonModule, InputTextModule],
})
export class IframeSectionComponent implements OnInit {
  @Input() sectionData: IframeData;
  @Output() sectionDataChange = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new IframeData();
    }
  }
}
